// ABOUTME: Password validation utilities for registration and password reset flows
// ABOUTME: Provides consistent validation logic across components following existing patterns

export const validatePassword = (password: string): string | null => {
  if (password.length === 0) return null; // No error for empty (before touched)
  if (password.length < 8) return 'Password must be at least 8 characters';
  if (password.length > 64) return 'Password must be 64 characters or less';
  return null;
};

export const validateConfirmPassword = (password: string, confirmPassword: string): string | null => {
  if (confirmPassword.length === 0) return null; // No error for empty (before touched)
  if (password !== confirmPassword) return 'Passwords do not match';
  return null;
};

export const isRegistrationFormValid = (
  email: string,
  password: string,
  confirmPassword: string,
  firstName: string,
  lastName: string
): boolean => {
  return (
    email.length > 0 &&
    firstName.length > 0 &&
    lastName.length > 0 &&
    password.length >= 8 &&
    password.length <= 64 &&
    password === confirmPassword
  );
};